import store from "@/stores/store";
import axios from "@/plugins/axios";
import utils from "@/stores/utils";
import documents from "./submodules/documents";

const state = {
    shipment: {},
    shipment_saving: false,
    shipment_saving_errors: null,

    options: [],
    options_loading: false,
    options_loading_errors: null,

    customers: [],
    customers_loading: false,
    customers_loading_errors: null,

    deliverysites: [],
    deliverysites_loading: false,
    deliverysites_loading_errors: null,

    shipment_type: null,
    delivery_date: null,
    stock: null,

    recipient: null,
    recipient_data: null,

    deliverysite: null,
    deliverysite_data: null,
};

const getters = {
    active_deliverysite(state) {
        return state.deliverysites.find((item) => {
            return item.id == state.shipment.deliverysite;
        });
    },
};

const mutations = {
    updateShipment(state, shipment) {
        state.shipment = JSON.parse(JSON.stringify(shipment || {}));
        state.shipment_saving = false;
        state.shipment_saving_errors = null;

        state.options = [];
        state.options_loading = false;
        state.options_loading_errors = null;

        state.delivery_date = shipment?.delivery_date;
        state.stock = null; // tobe fetched
        state.recipient = shipment?.recipient;
        state.recipient_data = state.customers.find(
            (item) => item.id == shipment?.recipient
        );
        state.deliverysite = shipment?.deliverysite;
        state.deliverysite_data = state.deliverysites.find(
            (item) => item.id == shipment?.deliverysite
        );

        if (state.shipment) {
            if (state.shipment.id) {
                if (state.shipment.deliverysite) {
                    if (state.shipment.recipient) {
                        state.shipment_type = "customerdeliverysite";
                    } else {
                        state.shipment_type = "mydeliverysite";
                    }
                } else if (state.shipment.recipient) {
                    state.shipment_type = "customer";
                } else {
                    state.shipment_type = "pickup";
                }
            } else {
                const persona = store.getters["session/current_entity_persona"];
                state.shipment_type =
                    ["retailer", "hospitality_group"].includes(persona) ? "mydeliverysite" : "customerdeliverysite";
            }
        } else {
            state.shipment_type = "pickup";
        }
    },
    updateShipmentType(state, shipment_type) {
        state.shipment_type = shipment_type;
        state.shipment.deliverysite = null;
        if (shipment_type == "customer") {
            state.shipment.deliverysite = null;
        } else if (shipment_type == "pickup") {
            state.shipment.deliverysite = null;
            state.shipment.recipient = null;
        } else if (shipment_type == "mydeliverysite") {
            state.shipment.deliverysite = null;
            state.shipment.recipient = null;
        }
    },
    updateShipmentSaving(state, saving) {
        state.shipment_saving = saving;
    },
    updateShipmentSavingErrors(state, errors) {
        state.shipment_saving_errors = errors;
    },
    updateOptions(state, options) {
        state.options = options;
    },
    updateOptionsLoading(state, deleting) {
        state.options_loading = deleting;
    },
    updateOptionsLoadingErrors(state, errors) {
        state.options_loading_errors = errors;
    },
    updateCustomers(state, customers) {
        state.customers = customers;
    },
    updateCustomersLoading(state, loading) {
        state.customers_loading = loading;
    },
    updateCustomersLoadingErrors(state, errors) {
        state.customers_loading_errors = errors;
    },
    updateDeliverySites(state, deliverysites) {
        state.deliverysites = deliverysites;
        if (!state.deliverysite_data) {
            state.deliverysite_data = state.deliverysites.find(
                (item) => item.id == state.shipment.deliverysite
            );
        }
    },
    updateDeliverySitesLoading(state, loading) {
        state.deliverysites_loading = loading;
    },
    updateDeliverySitesLoadingErrors(state, errors) {
        state.deliverysites_loading_errors = errors;
    },

    toggleOption(state, catalogentry) {
        if (!state.shipment.options) {
            state.shipment.options = [];
        }
        if (
            !state.shipment.options.find((item) => catalogentry.id == item.catalogentry)
        ) {
            state.shipment.options.push({ catalogentry: catalogentry.id });
        } else {
            state.shipment.options = state.shipment.options.filter(
                (item) => catalogentry.id != item.catalogentry
            );
        }
    },

    updateStock(state, stock) {
        state.stock = stock;
    },
    updateShipmentStock(state, stock_id) {
        state.shipment.stock = stock_id;

        if (stock_id && stock_id == state.deliverysite_data?.stock) {
            state.shipment.deliverysite = null;
            state.deliverysite = null;
            state.deliverysite_data = null;
        }
    },
    updateDeliveryDate(state, delivery_date) {
        state.shipment.delivery_date = delivery_date;
        state.delivery_date = delivery_date;
    },
    updateRecipient(state, recipient) {
        state.shipment.recipient = recipient;
        state.shipment.deliverysite = null;
        state.recipient = recipient;
        state.deliverysite = null;
        state.recipient_data = state.customers.find(
            (item) => item.id == state.recipient
        );
    },

    updateDeliverySite(state, deliverysite) {
        state.shipment.deliverysite = deliverysite;
        state.deliverysite = deliverysite;
        state.deliverysite_data = state.deliverysites.find(
            (item) => item.id == deliverysite
        );

    },
};

const actions = {
    async saveShipment({ commit, dispatch, state }, params) {

        commit("updateShipmentSaving", true);
        commit("updateShipmentSavingErrors", null);

        let url = "/api/shipments/";
        let method = axios.post;
        const shipment = JSON.parse(JSON.stringify(state.shipment || {}));

        switch (state.shipment_type) {
            case "customerdeliverysite":
                break;
            case "mydeliverysite":
                shipment.recipient = null;
                break;
            case "customer":
                shipment.deliverysite = null;
                break;
            case "pickup":
                shipment.recipient = null;
                shipment.deliverysite = null;
                break;
        }

        if (shipment.id) {
            url = `/api/shipments/${shipment.shipment_id}/`;
            method = axios.put;
        }
        try {
            const response = await method(url, shipment);
            commit("updateShipmentSaving", false);
            return response;
        } catch (xhr_error) {
            const error = utils.handleError(xhr_error);
            commit("updateShipmentSaving", false);
            commit("updateShipmentSavingErrors", error.details);
            throw error;
        } finally {
            dispatch("session/fetchStats", null, { root: true });
        }
    },

    async fetchOptions({ commit, dispatch, state }, params) {

        if (!state.shipment.stock) {
            commit("updateOptions", []);
            return;
        }
        commit("updateOptionsLoading", true);
        commit("updateOptionsLoadingErrors", null);

        try {
            const response = await axios.get(`/api/stocks/${state.shipment.stock}/operatoroptionscatalogentries/`, {
                params: { trigger: "shipment-option", ordering: "label" },
            });
            commit("updateOptions", response.data.results);
            return response;
        } catch (xhr_error) {
            const error = utils.handleError(xhr_error);
            commit("updateOptionsLoadingErrors", error.details);
            throw error;
        } finally {
            commit("updateOptionsLoading", false);
        }
    },

    async fetchCustomers({ commit, dispatch, state }, params) {

        commit("updateCustomersLoading", true);
        commit("updateCustomersLoadingErrors", null);

        try {
            const response = await axios.get("/api/customers/", {
                params: { limit: 1000, ordering: "name", profile: "customer" },
            });
            commit("updateCustomers", response.data.results);
            return response;
        } catch (xhr_error) {
            let error = utils.handleError(xhr_error);
            commit("updateCustomersLoadingErrors", error.details);
            throw error;
        } finally {
            commit("updateCustomersLoading", false);
        }
    },

    async fetchDeliverySites({ commit, dispatch, state }, params) {

        let url = null;
        if (state.shipment_type == 'customerdeliverysite') {
            if (!state.shipment.recipient) {
                return;
            }
            url = `/api/customers/${state.shipment.recipient}/deliverysites/`;
        } else if (state.shipment_type == 'mydeliverysite') {
            url = `/api/deliverysites/`;
        } else {
            return;
        }

        const viewPermission =
            state.shipment_type == "customerdeliverysite"
                ? "core.view_customer"
                : "core.view_deliverysite";
        if (
            store.getters["session/current_user_permissions"].indexOf(
                viewPermission
            ) == -1
        ) {
            return;
        }
        commit("updateDeliverySitesLoading", true);
        commit("updateDeliverySitesLoadingErrors", null);

        try {
            const response = await axios.get(url, {
                params: {
                    limit: 1000,
                    ordering: "name",
                },
            });
            commit("updateDeliverySites", response.data.results);
            if (!state.shipment.deliverysite && response.data.results.length == 1) {
                commit("updateDeliverySite", response.data.results[0].id);
            }
            return response;
        } catch (xhr_error) {
            let error = utils.handleError(xhr_error);
            commit("updateDeliverySitesLoadingErrors", error.details);
            throw error;
        } finally {
            commit("updateDeliverySitesLoading", false);
        }
    },


    changeStock({ commit, dispatch, state }, stock) {
        const stockId = stock?.id ?? stock ?? null;
        commit('updateStock', stock);
        commit('updateShipmentStock', stockId);
        dispatch("fetchStock");
        dispatch('fetchOptions');
    },

    async fetchStock({ commit, dispatch, state }, params) {
        if (!state.shipment.stock) {
            return;
        }
        const response = await axios.get(`/api/stocks/${state.shipment.stock}/`);
        commit("updateStock", response.data);
    },

    async init({ commit, dispatch, state }, params) {
        await commit("updateShipment", params.shipment);
        await dispatch("applyNewShipmentDefaults", params);
        dispatch("fetchStock");
        dispatch("fetchOptions");
        dispatch("fetchCustomers");
        dispatch("fetchDeliverySites");
    },
    changeShipmentType({ commit, dispatch, state }, shipment_type) {

        commit("updateShipmentType", shipment_type);
        dispatch("fetchDeliverySites");
    },

    changeRecipient({ commit, dispatch, state }, customer) {
        commit("updateRecipient", customer);
        dispatch("fetchDeliverySites");
    },

    async applyNewShipmentDefaults({ commit, dispatch, state }, params) {
        const shipment = params?.shipment || {};

        if (shipment.id) {
            return;
        }
        if (shipment.provider) {
            return;
        }
        if (shipment.stock) {
            return;
        }

        const entitySettings = store.getters["session/current_entity_settings"] || {};

        const settingsStockId = entitySettings.default_shipment_departure_stock ?? null;
        if (settingsStockId) {
            await dispatch("changeStock", settingsStockId);
        } else {
            try {
                const response = await axios.get("/api/stocks/", {
                    params: { limit: 2, ordering: "-main,name" },
                });
                const stocks = response?.data?.results || [];
                if (stocks.length === 1) {
                    await dispatch("changeStock", stocks[0].id);
                } else if (stocks.length > 1) {
                    const mainStock = stocks.find((s) => s.main) || null;
                    if (mainStock) {
                        await dispatch("changeStock", mainStock.id);
                    }
                }
            } catch (e) {
                // Defaults are best-effort; keep current behavior on errors.
            }
        }

        const hasRecipient = Boolean(shipment.recipient || shipment.recipient_data);
        if (hasRecipient) {
            return;
        }

        const settingsType = entitySettings.default_standalone_shipment_type ?? null;
        if (settingsType) {
            dispatch("changeShipmentType", settingsType);
        }
    },
};

export default {
    namespaced: true,
    state,
    getters,
    actions,
    mutations,
    modules: {
        documents: documents(),
    },
};
